import axios from "axios";
import { LyricsResponse } from "../Models/LyricsResponse";

export const fetchLyrics = async (lyricsId: string, language: string): Promise<LyricsResponse> => {
  // `l` selects the language (backend reads it, preferring it over Accept-Language)
  // and keeps the URL unique per language so the browser cache can't collide.
  // No app scoping: by-id fetches are not domain-filtered by the server, and
  // `platform=web` (Omni) is the superset — every app resolves its own nodes.
  const response = await axios.get<LyricsResponse>(
    `/api/graph/nodes/${lyricsId}?platform=web&l=${encodeURIComponent(language)}`
  );
  return response.data; // Ensure this matches the LyricsResponse structure
};
